

import { FaPlay, FaPause, FaStepForward, FaStepBackward, FaRedo, FaList } from "react-icons/fa"
import "../styles/Controls.css"
import Button from "../../shared/Button"

function Controls({
  text,
  pattern,
  speed,
  isPlaying,
  onTextChange,
  onPatternChange,
  onSpeedChange,
  onPlayPause,
  onStepForward,
  onStepBackward,
  onReset,
  onRun,
  showLogs,
  toggleLogs,
}) {
  return (
    <div className="bmcontrols">
      <div className="bminput-bmcontrols">
        <div className="bminput-group">
          <label htmlFor="text-bminput">Text:</label>
          <input
            id="text-bminput"
            type="text"
            value={text}
            onChange={onTextChange}
            placeholder="Enter text (e.g., ABAAABCDABABCABCABAABC)"
          />
        </div>

        <div className="bminput-group">
          <label htmlFor="pattern-input">Pattern:</label>
          <input
            id="pattern-input"
            type="text"
            value={pattern}
            onChange={onPatternChange}
            placeholder="Enter pattern to search for (e.g., ABCAB)"
          />
        </div>

        <div className="bminput-group">
          <label htmlFor="bmspeed-input">Speed:</label>
          <input id="bmspeed-input" type="range" min="0.5" max="3" step="0.5" value={speed} onChange={onSpeedChange} />
          <span className="speed-value">{speed}x</span>
        </div>
      </div>

      <div className="bmplayback-bmcontrols">
        <Button onClick={onRun}>Run Algorithm</Button>

        <Button variant="secondary" size="sm" onClick={onStepBackward}><FaStepBackward /></Button>

        <Button variant="secondary" size="sm" onClick={onPlayPause}>{isPlaying ? <FaPause /> : <FaPlay />}</Button>

        <Button variant="secondary" size="sm" onClick={onStepForward}><FaStepForward /></Button>

        <Button variant="secondary" size="sm" onClick={onReset}><FaRedo /></Button>

        {/* <button
          className={`bmcontrol-button logs-button ${showLogs ? "active" : ""}`}
          onClick={toggleLogs}
          title="Toggle Comparison Logs"
        >
          <FaList />
        </button> */}
      </div>
    </div>
  )
}

export default Controls

